export enum AnalyticType {
  SOWING = 'sowing',
  WEEDS = 'weeds',
  SAT_NEMATODES = 'sat-nematodes',
  SAT_HARVEST = 'sat-harvest',
  SAT_PIXEL_ANOMALY = 'sat-pixel-anomaly',
  SAT_SUGAR = 'sat-sugar',
  SAT_SOIL_MOISTURE = 'sat-soil-moisture',
  FLOWERING = 'flowering',
  LAND_USE = 'land-use',
  DEFORESTATION = 'deforestation'
}

// Analytics whose build VM no longer exists in dev-processing-v2, so they can't be built or deployed.
// They stay in the list (old models still reference them) but are shown crossed out.
export const DISABLED_ANALYTICS: Partial<Record<AnalyticType, string>> = {
  [AnalyticType.DEFORESTATION]: 'Build VM removed on 2026-10-10 (snapshot kept)',
  [AnalyticType.SAT_NEMATODES]: 'Removed from deploy-service in SW-7950',
  [AnalyticType.SAT_SOIL_MOISTURE]: 'No build VM or image left',
  [AnalyticType.FLOWERING]: 'No build VM or image left'
};

export function isAnalyticDisabled(analytic: string): boolean {
  return analytic in DISABLED_ANALYTICS;
}

export function getDisabledReason(analytic: string): string {
  return DISABLED_ANALYTICS[analytic as AnalyticType] || '';
}
